import { render } from "./GooglePlayLink.vue?vue&type=template&id=903aee96"
import script from "./GooglePlayLink.vue?vue&type=script&lang=js"
export * from "./GooglePlayLink.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__